﻿export interface ITicketPropertiesRequest {
    id: number;
    groupId: number;
    assignedUserId: number;
    entityType: number;
    entityTypeId: number;
    ticketStatusId: number;
    ticketTypeId: number;
    tierLevelId: number;
    urgency: number;
    tags: string[];
}
